import React from "react"
import SEO from "../components/seo"
import Video from "../components/Video"
import VideoMobile from "../components/VideoMobile"

export default function DiorPage(props) {
  return (
    <div id="dior-tied-with-love">
      <VideoMobile
        title="Dior, Tied With Love  • Directed by Arnaud Bresson"
        src="https://player.vimeo.com/video/1234393885?&title=0&muted=0"
        allowsInlineMediaPlayback="true"
      />
      <Video
        title="Dior, Tied With Love  • Directed by Arnaud Bresson"
        src="https://player.vimeo.com/video/1234393885?background=1&autoplay=1&loop=1&byline=0&title=0&muted=0"
      />
      <SEO title={props.title} />
    </div>
  )
}
